<template>
  <div class="indicador-container">
    <div class="ind-top">
      <span class="ind-title">{{ label }}</span>
      <div class="ind-icon-wrap" :class="badgeClass">
        <i :class="iconClass"></i>
      </div>
    </div>

    <p v-if="caption" class="ind-caption">{{ caption }}</p>

    <div class="ind-middle">
      <span class="ind-value">{{ value }}</span>
      <span v-if="unit" class="ind-unit">{{ unit }}</span>
    </div>

    <div class="ind-bottom" :class="{ 'ind-bottom--neutral': !showTrend }">
      <span v-if="showTrend" class="ind-arrow">↗</span>
      <span class="ind-variation">{{ variation }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndicadorCard',
  props: {
    label: { type: String, required: true },
    value: { type: [Number, String], required: true },
    unit: { type: String, default: '' },
    variation: { type: String, required: true },
    showTrend: { type: Boolean, default: false },
    caption: { type: String, default: '' }
  },
  computed: {
    badgeClass () {
      // Se for funcionários, retorna o badge verde. Caso contrário, laranja.
      if (this.label.includes('FUNCIONÁRIOS') || this.label.includes('FUNCIONARIOS')) {
        return 'badge-green'
      }
      return 'badge-orange'
    },
    iconClass () {
      if (this.label.includes('FUNCIONÁRIOS') || this.label.includes('FUNCIONARIOS')) return 'fas fa-users'
      if (this.label.includes('ANÁLISES') && !this.label.includes('DURAÇÃO') && !this.label.includes('DURACAO')) return 'fas fa-microscope'
      return 'far fa-clock'
    }
  }
}
</script>

<style scoped>
.indicador-container {
  background-color: #ffffff !important;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.03), 0 2px 4px -1px rgba(0, 0, 0, 0.02);
  height: 100%;
}

.ind-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.ind-title {
  font-size: 11px;
  font-weight: 700;
  color: #8e9baa;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ind-caption {
  margin: -16px 0 16px 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  color: #8e9baa;
}

.ind-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

/* Cores idênticas aos selos do Visily */
.badge-orange {
  background-color: #FFF4ED;
  color: #FF8A00;
}

.badge-green {
  background-color: #ECFDF5;
  color: #10B981;
}

.ind-middle {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 20px;
}

.ind-value {
  font-size: 36px;
  font-weight: 800;
  color: #111827;
  line-height: 1;
}

.ind-unit {
  font-size: 14px;
  font-weight: 600;
  color: #6B7280;
  white-space: nowrap;
}

.ind-bottom {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #F59E0B; /* Cor amarela/laranja da variação no Visily */
}

.ind-bottom--neutral {
  color: #6B7280;
}

.ind-arrow {
  font-size: 14px;
  font-weight: bold;
}
</style>
